import { CPsCellRenderer } from "../../../../../../shared/components/CustomCells/CPsCellRenderer";
import { ColumnsFactory} from "../../../../../../shared/components/Grid/functions";
import './styles.css';

const ColumnsExpatriados = (translate) =>[
  ColumnsFactory.DateColumn(translate("expatriado-desde"), "fechaExpatriadoDesde"),
  ColumnsFactory.DateColumn(translate("expatriado-hasta"), "fechaExpatriadoHasta"),
  ColumnsFactory.DateColumn(translate("facturacion-inicial"), "fechaFacturacionExpatriadoInicial"),
  ColumnsFactory.DateColumn(translate("facturacion-final"), "fechaFacturacionExpatriadoFinal"),
  ColumnsFactory.TextColumn(translate("empresa"), "empresaExpatriadoNombre"),
  ColumnsFactory.TextColumn(translate("centro-costo-destino"), "centroCostoDestinoExpatriado"),
  ColumnsFactory.TextColumn(translate("grupoFactura"), "grupoFacturaExpatriado"),
  ColumnsFactory.TextColumn(translate("centro-costo-origen-factura"), "referenciaFacturaExpatriado")
]

const Roles = {'AD':'Administrador', 'ADL':'Administrador Local', 'CON':'Consulta', '*':'Administrador Global'}

export const getColumnDefs = (translate,currentUser) => {

  return [
    ColumnsFactory.TextColumn(translate('dni'), "dni",{pinned:'left'}),
    ColumnsFactory.TextColumn(translate('usuario'), "login",{pinned:'left'}),
    ColumnsFactory.TextColumn(translate('nombre'), "nombre",{pinned:'left'}),
    ColumnsFactory.TextColumn(translate('dn-sg-id'), "idDN"),
    ColumnsFactory.TextColumn(translate('dn-sg'), "direccionNegocio"),
    ColumnsFactory.TextColumn(translate('mi-rol'), 'rol',{cellRendererFramework:(params)=> Roles[params.value]}),
    ColumnsFactory.TextColumn(translate('provincia-cotizacion'), "provincia"),
    ColumnsFactory.TextColumn("Email", "email"),
    ColumnsFactory.DateColumn(translate('fecha-baja'), "fechaBaja"),
    ColumnsFactory.GroupColumn(translate('datos-expatriacion'), ColumnsExpatriados(translate), 'header-group-expatriados-grid'),
  ];
};